<template>
  <div class="dashboard-container" id="food-app">
    <div class="container">
      <div class="tableBar">
        <el-input
          v-model="input"
          placeholder="请输入商家名称"
          style="width: 250px;margin-top: 20px"
          clearable
          @keyup.enter="handleQuery"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            style="cursor: pointer"
            @click="init"
          ></i>
        </el-input>

        <el-button type="danger" @click="sousuo"> 搜索</el-button>

        <!-- <el-button type="primary" @click="addBook"> 新增商户</el-button> -->

      </div>



      <el-table
  :data="tableData"
  stripe
  class="tableBox"
  @selection-change="handleSelectionChange"
>
  <!-- 多选框 -->
  <el-table-column
    type="selection"
    width="55"
  ></el-table-column>

  <!-- 书籍序号 -->
  <el-table-column
    prop="id"
    label="商户ID"
    width="80"
  ></el-table-column>

  <!-- 书籍名称 -->
  <el-table-column
    prop="username"
    label="商户名称"
    min-width="120"
  ></el-table-column>



  <!-- 标题 -->
  <el-table-column
    prop="password"
    label="商户密码"
    min-width="150"
  ></el-table-column>

  <!-- 作者 -->
  <el-table-column
    prop="phone"
    label="商户电话"
    min-width="100"
  ></el-table-column>

  <!-- 状态 -->
  <el-table-column
    prop="addr"
    label="商户地址"
    width="80"
  >
  </el-table-column>


  <!-- 操作 -->
  <el-table-column
    label="操作"
    width="160"
    align="center"
  >
    <template #default="scope">
      <el-button
        type="primary"
        size="small"
        class="blueBug"
        @click="editBookStatus(scope.row)"
        style="margin-bottom:8px ; margin-left: 10px;"
        icon="el-icon-edit"
      >
        修改商户信息
      </el-button>
      <el-button
        type="danger"
        size="small"
        class="delBut non"
        @click="deleteBook(scope.row.id)"
        icon="el-icon-delete"
      >
      删除商户信息
      </el-button>
    </template>
  </el-table-column>
</el-table>
      <el-pagination
        class="pageList"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="counts"
        @size-change="handleSizeChange"
        v-model:current-page="page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>


    <el-dialog title="商户信息" v-model="dialogTableVisible">
  <el-form label-width="180px" :model="bookmsg">
    <el-form-item label="商户序号:" style="width: 800px">
      <el-input disabled v-model="bookmsg.id" readonly></el-input>
    </el-form-item>
    <el-form-item label="商户名称:" style="width: 800px">
      <el-input v-model="bookmsg.username"></el-input>
    </el-form-item>
    <el-form-item label="商户密码:" style="width: 800px">
      <el-input v-model="bookmsg.password"></el-input>
    </el-form-item>
    <el-form-item label="商户地址:" style="width: 800px">
      <el-input v-model="bookmsg.addr"></el-input>
    </el-form-item>
    <el-form-item label="商户联系电话:" style="width: 800px">
      <el-input v-model="bookmsg.phone"></el-input>
    </el-form-item>
    <!-- <el-form-item label="商户是否支持优惠券:" style="width: 800px">
      <el-select v-model="bookmsg.type" placeholder="请选择状态">
        <el-option label="支持" value=0></el-option>
        <el-option label="不支持" value=1></el-option>
      </el-select>
    </el-form-item> -->
 
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogTableVisible = false">取 消</el-button>
    <el-button type="primary" @click="quedingedit(bookmsg)">确 定</el-button>
  </span>
</el-dialog>


  </div>


</template>

<script>
import axios from "axios";





export default {
  name: 'Manage',
  data() {
    return {
      tableData: [],
      typeNameArr: [],
      pagesize:10,
      page:1,
      input: '',
      msg: '',
      counts:0,
      dialogTableVisible:false,
      bookmsg: {
      id: null, // 书籍序号
      username: '', // 书籍名称
      phone: null, // 价格
      password: '', // 书籍标题
      addr: '', // 书籍作者
      type: '0', // 状态，默认为上架
    }
    }
  },



  mounted() {
this.init()
  },
  methods: {



    init(){
      const params = {
        page: this.page,
        pagesize: this.pagesize,
        input: this.input ? this.input : undefined
      }
      axios.get('http://localhost:8090/mer/getMymsg',{
        params
        }
        )
        .then(response => {
          this.tableData=response.data.data.records
          this.counts=response.data.data.total
          // 请求成功时的处理逻辑
          console.log(this.tableData)

        })
        .catch(error => {
          // 请求失败时的处理逻辑
          console.error(error); // 输出错误信息
        });
    },

    
    editBookStatus(data){
this.bookmsg=data
this.msg="修改"
this.dialogTableVisible=!this.dialogTableVisible;
    },

  //点击搜索执行方法即可
  sousuo(){
    this.init();
  },
  

  handleUploadSuccess(response){

    this.bookmsg.image=response.data
  },

  addBook(){
this.bookmsg={}
this.msg="111"
this.dialogTableVisible=!this.dialogTableVisible;
  },
    quedingedit(data){
      if(this.msg=="修改"){
        this.$confirm('确认修改商户信息, 是否继续?', '确定修改', {
        'confirmButtonText': '确定',
        'cancelButtonText': '取消',
      }).then(()=>{
        axios.post('http://localhost:8090/mer/update',data)
          .then(response=> {
            // 请求成功时的处理逻辑
            this.$message.success("修改成功！")
            this.dialogTableVisible=false
          this.init();
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      })
      }else{
        this.$confirm('确认新增书籍信息, 是否继续?', '确定新增', {
        'confirmButtonText': '确定',
        'cancelButtonText': '取消',
      }).then(()=>{
        axios.post('http://localhost:8090/SysBook/add',data)
          .then(response=> {
            // 请求成功时的处理逻辑
            this.$message.success("新增成功！")
            this.dialogTableVisible=false
          this.init();
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      })
      }
    },
    handleQuery(){
      console.log(666)
    },

    removeImage() {
    this.bookmsg.image = ''; // 清空图片URL

  },
    deleteBook(data){
      this.$confirm('确认删除该商户消息吗, 是否继续?', '确定删除', {
        'confirmButtonText': '确定',
        'cancelButtonText': '取消',
      }).then(()=>{
        axios.get('http://localhost:8090/mer/delete?id='+data)
          .then(response => {
            // 请求成功时的处理逻辑
            this.$message.success("删除成功！")
            this.dialogTableVisible=false
          this.init();
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      })
    },
    // 全部操作
    handleSelectionChange (val){
      let checkArr = []
      val.forEach((n) => {
        checkArr.push(n.id)
      })
      this.checkList = checkArr
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.init()
    },

    handleRemove(file, fileList) {
    this.bookmsg.image = ''; // 清空图片URL
 
  },

    handleCurrentChange (val) {
      this.page = val
      this.init()
    }

  }
}
</script>

<style lang="less" scoped>
.manage {
    padding: 16px;
}
</style>
